/*
 *   File : orders-sort.js
 *   Author : https://evoqins.com
 *   Description : Orders sort modal component
 *   Integrations : 
 *   Version : 1.0.0
*/

import React from 'react';

//Style
import style from "../../Styles/Component/modal.module.scss";

//Custom components
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';

const OrdersSortModal = (props) => {
    return (
        <div className={`${style.e_basket_sort_modal} e-bg-white border-radius-16 p-3 position-absolute top-50px z-index-999 w-360px w-280px-res`}>
            <div className='d-flex align-items-center justify-content-between'>
                <h6 className='e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-700 line-height-24px'>
                    Sort by
                </h6>
                {/* <div className='d-flex gap-1 align-items-center cursor-pointer'
                    onClick={props.handleClear}>
                    <span className='e-font-12-res e-text-primary-color e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                        Clear all
                    </span>
                    <Icon icon="clear-icon"
                        size="16px"
                        className="d-flex" />
                </div> */}
            </div>

            {/* Options */}
            <div className={`${style.e_order_sort_modal_body} overflow-scroll pb-2 mt-4 d-flex flex-column gap-12px`}>
                {props.options.map((option, key) => (
                    <div key={key} className=' d-flex gap-2 align-items-center cursor-pointer'
                        onClick={() => props.handleSelect(option.id)}>
                        <Icon icon={props.selected === option.id ? "radio-active" : "radio-inactive"}
                            className="d-flex w-16px w-12px-res" />
                        <p className='e-font-12-res mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                            {option.label}
                        </p>
                    </div>
                ))}
            </div>

            {/* Custom buttons */}
            <div className='pt-2 d-flex justify-content-end gap-3'>
                <SecondaryButton name="Cancel"
                    className="bg-transparent"
                    padding="padding-40px-lr"
                    onPress={props.handleCancel} />
                <PrimaryButton name="Apply"
                    padding="padding-40px-lr padding-8px-tb py-2"
                    onPress={props.handleApply} />

            </div>
        </div>
    )
}

export default OrdersSortModal;
